export const SAML_SSO_DEFAULT_VALUES = {
    crm: {
        idpUrl: '',
        idpId: ''
    }
};


// WEBPACK FOOTER //
// ./src/constants/SamlSsoDefaultValues.js